
import { useState } from 'react';

const services = [
  {
    title: '空运服务',
    description: '快速可靠的全球航空货运服务，提供具有竞争力的价格和准时交付保障。',
    icon: 'ri-plane-line',
  },
  {
    title: '海运服务',
    description: '经济高效的整箱（FCL）和拼箱（LCL）海运解决方案，通达全球主要港口。',
    icon: 'ri-ship-line',
  },
  {
    title: '陆运服务',
    description: '全面的公路运输和铁路运输服务，覆盖国内及跨境配送需求。',
    icon: 'ri-truck-line',
  },
  {
    title: '仓储服务',
    description: '安全的仓储设施，提供库存管理和分拨配送服务。',
    icon: 'ri-building-line',
  },
  {
    title: '报关清关',
    description: '专业的报关代理服务，确保您的货物顺利通关。',
    icon: 'ri-file-list-3-line',
  },
  {
    title: '供应链解决方案',
    description: '根据您的业务需求量身定制的端到端物流管理方案。',
    icon: 'ri-links-line',
  },
];

export default function ServicesSection() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            我们的<strong>物流服务</strong>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            全面的货运代理和供应链解决方案，满足您的各类业务需求
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-gray-50 rounded-lg p-8 transition-all duration-300 cursor-pointer ${hoveredIndex === index ? 'shadow-xl -translate-y-1' : 'hover:shadow-xl hover:-translate-y-1'}`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="w-16 h-16 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
